module.exports = __webpack_public_path__ + "static/media/competition.33809f66.jpg";